<template>
    <!-- <header>
        <router-link :to="{path: '/'}">Домой</router-link>
    </header> -->
    <main>
        <!-- Auth layout -->
        <slot/>
    </main>
</template>
<script>

export default {
    name: 'AuthLayout'
}
</script>
